var _g, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconVideoOff = function SvgIconVideoOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.1885 7.85693C22.0901 7.81911 21.9953 7.80012 21.9043 7.80012C21.6997 7.80012 21.5294 7.87226 21.3929 8.01613L16.8122 12.5855V10.7101C16.8122 9.80823 16.4921 9.03733 15.8517 8.39697C15.2114 7.75668 14.4405 7.43652 13.5386 7.43652H5.53686C4.63522 7.43652 3.86415 7.75668 3.22375 8.39697C2.58359 9.03733 2.26343 9.80823 2.26343 10.7101V18.712C2.26343 19.6137 2.58359 20.3846 3.22379 21.0249C3.86419 21.6652 4.63526 21.9854 5.5369 21.9854H13.5387C14.4406 21.9854 15.2114 21.6652 15.8518 21.0249C16.4921 20.3846 16.8123 19.6138 16.8123 18.712V16.825L21.393 21.4057C21.5295 21.5496 21.6998 21.6217 21.9044 21.6217C21.9954 21.6217 22.0901 21.6027 22.1886 21.565C22.4843 21.4361 22.632 21.2127 22.632 20.8944V8.52771C22.6318 8.2093 22.4842 7.9858 22.1885 7.85693Z",
    fill: "#F34D4F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.0934,
    y: 0.141001,
    width: 2.24896,
    height: 33.7474,
    rx: 1.12448,
    transform: "rotate(40.5787 22.0934 0.141001)",
    fill: "#F34D4F",
    stroke: "white",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVideoOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-video-off.95d1f1f1.svg";
export { ForwardRef as ReactComponent };